var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortAsc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.47889 10.5524C7.73924 10.8128 7.73923 11.2349 7.47889 11.4952L5.59327 13.3808C5.33292 13.6412 4.91081 13.6412 4.65046 13.3808L2.76484 11.4952C2.50449 11.2349 2.50449 10.8128 2.76484 10.5524C3.02519 10.2921 3.4473 10.2921 3.70765 10.5524L4.4552 11.3L4.45451 4.94287C4.45451 4.57468 4.75299 4.2762 5.12118 4.2762C5.48937 4.2762 5.78784 4.57468 5.78784 4.94287L5.78853 11.2999L6.53608 10.5524C6.79643 10.2921 7.21854 10.2921 7.47889 10.5524Z",
    fill: "#7799A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.56884 5.96656C8.30849 5.70621 8.30849 5.2841 8.56884 5.02375L10.4545 3.13813C10.7148 2.87778 11.1369 2.87778 11.3973 3.13813L13.2829 5.02375C13.5432 5.2841 13.5432 5.70621 13.2829 5.96656C13.0225 6.22691 12.6004 6.22691 12.3401 5.96656L11.5925 5.21901L11.5932 10.9094C11.5932 11.2776 11.2947 11.5761 10.9266 11.5761C10.5584 11.5761 10.2599 11.2776 10.2599 10.9094L10.2592 5.21901L9.51165 5.96656C9.2513 6.22691 8.82919 6.22691 8.56884 5.96656Z",
    fill: "#1C3D45"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAsc);
export default __webpack_public_path__ + "static/media/sort_asc.d9dd9ba420161791e952229018f22d06.svg";
export { ForwardRef as ReactComponent };